import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PersonPaymentForm, PersonRegistrationResource } from 'src/app/models/iregistration.interface';
import { GLOBAL_CONVERTERS } from '../../global.converters';

@Component({
  selector: 'app-person-conference-payment-view',
  templateUrl: './person-conference-payment-view.component.html',
  styleUrls: ['./person-conference-payment-view.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonConferencePaymentViewComponent implements OnInit {
  @Input() data: PersonRegistrationResource;
  @Input() isReadOnly: boolean = true;
  @Output() edit = new EventEmitter<PersonPaymentForm>();

  constructor() { }

  ngOnInit(): void {
  }

  onEdit() {
    const form = {
      isPayment: this.data.isPayment,
      datePayment: this.data.datePayment || GLOBAL_CONVERTERS.getStringFromDateTime(new Date()),
      isMaterials: this.data.isMaterials,
      paymentDocument: this.data.paymentDocument,
      paymentTypeId: this.data.paymentTypeId,
      paymentAmount: this.data.paymentAmount,
      sponsorId: this.data.sponsorId
    } as PersonPaymentForm;
    this.edit.emit(form);
  }

}
